// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"243":"4c05d068","414":"4c05d068","667":"4c05d068","738":"4c05d068","933":"4c05d068"}[chunkId] + ".chunk.css";
};